import { ViewFareEstimateModalComponent } from "../modal-components/view-fare-estimate-modal/view-fare-estimate-modal.component";
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Helper } from "src/app/core/helpers/helper";
import { TripReassignModalComponent } from "../modal-components/trip-reassign-modal/trip-reassign-modal.component";
import { BookingService } from "../services/booking.service";
import { HistoryService } from "../services/history.service";

@Component({
  selector: "app-ride-details",
  templateUrl: "./ride-details.component.html",
  styleUrl: "./ride-details.component.scss",
  standalone: false
})
export class RideDetailsComponent {
  @Input() bookingDetails: any;
  @Input() bookingType: any;
  @Output() updateBookingsOnReassign = new EventEmitter();
  @Output() goBack = new EventEmitter();
  constructor(public helper: Helper, private bookingService: BookingService, private historyService: HistoryService) {}

  @ViewChild("reassignModal", { static: true }) reassignModal!: TripReassignModalComponent;
  @ViewChild("viewEstimateModal", { static: true }) viewEstimateModal!: ViewFareEstimateModalComponent;
  ngOnInit(): void {}

  /**
   * Retrieves the booking type string based on the provided tag.
   *
   * @param tag The tag representing the booking type.
   * @returns The translated booking type string.
   */
  getBookingTypeString(tag: any): string {
    const key = this.helper.BookingTypeString[tag as keyof typeof this.helper.BookingTypeString];
    let string;
    if (key) {
      string = this.helper.translateService.instant(key);
    }
    return string;
  }

  /**
   * Handles the image error event by setting a default user image.
   *
   * @param event The event object containing the image error details.
   */
  handleImageError(event: any): void {
    event.target.src = this.helper.DefaultImages.DefaultUserImage;
  }

  /**
   * Checks the schedule array for the presence of "SCHEDULE" and returns the corresponding booking type.
   *
   * @param arr The array of schedule strings.
   * @returns The booking type (SCHEDULE or NOW).
   */
  checkSchedule(arr: string[]): number {
    if (arr.includes("SCHEDULE")) {
      return this.helper.BookingType.SCHEDULE;
    }
    return this.helper.BookingType.NOW;
  }

  /**
   * Opens the reassign trip modal with the current booking details.
   */
  onReassignTrip(): void {
    this.reassignModal.openModal(this.bookingDetails);
  }

  /**
   * Emits the goBack event to navigate back to the previous view.
   */
  onBack(): void {
    this.goBack.emit();
  }

  /**
   * Reassigns the booking to a new driver and updates the bookings list.
   *
   * @param driverId The ID of the new driver.
   */
  reassignBooking(driverId: any): void {
    const json = {
      bookingId: this.bookingDetails._id,
      driverId: driverId
    };

    this.bookingService.reassignBooking(json).subscribe(() => {
      this.updateBookingsOnReassign.emit();
      if (this.reassignModal) {
        this.reassignModal.closeModal();
      }
    });
  }

  /**
   * Retrieves the running booking details and displays the fare estimate modal.
   */
  viewEstimate(): void {
    this.historyService.getRunningBookingDetails(this.bookingDetails._id).subscribe((response: any) => {
      this.viewEstimateModal.showModal(response.booking, this.bookingDetails.bookingInvoice);
    });
  }
}
